(function($){

	/** --------------------------------------------------
	*
	*   pages - cart - CART PAGE
	*
	*   INFO
	*   this file contains all of the javascript that is
	*   unique to the shopping cart page
	*
	*   TABLE OF CONTENTS
	*   window load
	*   drupal behaviour
	*   delivery methods
	*   page layout
	*   coupons block
	*   helper functions
	*
	*   -------------------------------------------------- */




	/** --------------------------------------------------
		#window load
		-------------------------------------------------- */

		$(window).on('load', function () {
			if(isCartPage()) {

				/* setup coupons block: */
				setupCouponsBlockForm();

				/* setup page layout: */
				setupPageLayout();

        // Force Flickity bargains list to trigger recalculation
        if ($('.bargains-list').length) {
          window.dispatchEvent(new Event('resize'));
        }

				let checkoutBtn = $('.view-commerce-cart-form .form-actions .fancy-button:first-child');
				let emptyCartBtn = $('.view-commerce-cart-form .form-actions .fancy-button:last-child');

				let checkoutBtnClone = checkoutBtn.clone();
				let emptyCartBtnClone = emptyCartBtn.clone();

				if(!emptyCartBtn.is(':empty')){
					checkoutBtn.replaceWith(emptyCartBtnClone);
					emptyCartBtn.replaceWith(checkoutBtnClone);
				}

				/* loaders */
				/* ******* */

				/* add a loader when processing stuff - because
				 * pages can take some time to load
				 */

				// form actions:
				$(document).on('click', '.form-commerce-cart .form-actions .form-submit', function(e) {
					$('html').addClass('js-ajaxloader-loading');
					$('.js-ajax-loader').removeAttr('hidden');
				});

				// remove item:
				$(document).on('click', '.form-commerce-cart .delete-order-item', function(e) {
					$('html').addClass('js-ajaxloader-loading');
					$('.js-ajax-loader').removeAttr('hidden');
				});

				// update quantity:
				$(document).on('change', '.form-commerce-cart .custom-edit-quatity', function(e) {
					$('html').addClass('js-ajaxloader-loading');
					$('.js-ajax-loader').removeAttr('hidden');
				});

			}
		});



	/** --------------------------------------------------
		#ajax complete
		-------------------------------------------------- */

		$(document).ajaxComplete(function(event, xhr, settings) {
			if(isCartPage()) {

				/* setup coupons block: */
				setupCouponsBlockForm();

			}
		});




	/** --------------------------------------------------
		#drupal behaviour
		-------------------------------------------------- */

		Drupal.behaviors.shoppingCartPage = {
			attach: function (context, settings) {
				if(isCartPage()) {

					/* setup page layout: */
					setupPageLayout();

          /* setup bargains list */
          setupBargainsList();

				}
			}
		};




	/** --------------------------------------------------
		#page layout
		-------------------------------------------------- */

		/* we need to change the layout of the shopping
		 * cart page
		 * -> we need to insert some extra wrappers that
		 *    can't easily be added in drupal
		 */

		function setupPageLayout() {
			/* wrapper around "coupons" and "price": */

			let $existingCouponsPriceWrapper = $(document).find('.cart-page__coupons-and-price-wrapper');
			if($existingCouponsPriceWrapper.length === 0) {

				let $ajaxCouponsBlock = $(document).find('#coupons-ajax-wrapper');
				let $priceBlock = $(document).find('.view-commerce-cart-form .hairco-commerce-order-summary-wrapper');
				if($ajaxCouponsBlock.length > 0 && $priceBlock.length > 0) {

					$ajaxCouponsBlock.wrap('<div class="cart-page__coupons-wrapper"></div>');
					$priceBlock.wrap('<div class="cart-page__price-block-wrapper"></div>');

					let newBlock = $('<div class="cart-page__coupons-and-price-wrapper"></div>');
					newBlock.insertBefore('.cart-page__coupons-wrapper');

					$(".cart-page__coupons-wrapper").appendTo(".cart-page__coupons-and-price-wrapper");
					$(".cart-page__price-block-wrapper").appendTo(".cart-page__coupons-and-price-wrapper");
				}
			}

			// add finished class:
			if(!$('body').hasClass('js-cart-layout-finished')) {
				$('body').addClass('js-cart-layout-finished');
			}
		} /* setupPageLayout */




	/** --------------------------------------------------
		#coupons block
		-------------------------------------------------- */

		function setupCouponsBlockForm() {

			/* we want to move the "apply coupon" button
			 * inside of the form-input-block (for css
			 * positioning)
			 */

			let $couponButton = $(document).find('#coupons-ajax-wrapper .form-submit[data-drupal-selector="edit-coupons-apply"]');
			let $couponInputFormBlock = $(document).find('#coupons-ajax-wrapper .coupon-input-block__content');
			if($couponButton.length > 0 && $couponInputFormBlock.length > 0) {

				// -> add wrapper and move the coupon button:
				$couponInputFormBlock.append($couponButton);
				$couponButton.wrap('<div class="coupon-input-block__button-zone"></div>');

				const $couponSummary = $('#coupon_summary');
				if($couponSummary.length > 0) {
					const $couponBlock = $(document).find('.cart-page__coupons-wrapper');
					$couponSummary.appendTo($couponBlock);
				}

				// -> add finished classes:
				if(!$couponInputFormBlock.hasClass('js-has-coupon-button')) {
					$couponInputFormBlock.addClass('js-has-coupon-button');
				}
				if(!$('#coupons-ajax-wrapper').hasClass('js-finished')) {
					$('#coupons-ajax-wrapper').addClass('js-finished');
				}
				if(!$('body').hasClass('js-cart-couponslayout-finished')) {
					$('body').addClass('js-cart-couponslayout-finished');
				}

			}

		} /* setupCouponsBlockForm */




	/** --------------------------------------------------
		#helper functions
		-------------------------------------------------- */

		function isCartPage() {
			let isCartPage = false;

			if($('body').hasClass('path-cart')) {
				isCartPage = true;
			}

			return isCartPage;
		} /* isCartPage */



	/** --------------------------------------------------
		#bargains
		-------------------------------------------------- */

    function setupBargainsList() {
      if ($('.bargains-list').length) {
        const nrOfSlides = $('.bargains-list').find('.commerce-product--view-mode-teaser').length;
        const showBargainsButtons = nrOfSlides > 1 ? true : false;

        var bargains = new Flickity('.bargains-list', {
          cellAlign: 'left',
          draggable: true,
          freeScroll: true,
          groupCells: true,
          prevNextButtons: showBargainsButtons,
          arrowShape: 'M8 9.5v-9L2 5z',
          pageDots: false,
          imagesLoaded: true,
        });
      }
    }


	})(jQuery);
